import React from 'react';
import './Header.css';


const Footer = () => {
    return(
        <div style={{width:'100%',display:'inline-block',color:"black"}}>
            <hr/>
            <div>
                <center>
                    <h6>&copy; Newton Park Hotels &nbsp;({new Date().getFullYear()})</h6>
                    <i className="fa fa-map-marker"></i> &nbsp;No 8 Cape Town Street, Off Ibrahim Babangida Way, Wuse Zone 4, Abuja, Nigeria.
                    <p><i className="fa fa-phone"></i>&nbsp;+234 803 310 5413, +234 913 009 7280</p>
                    <div>
                    <span classname="twitr">
                            <a href="http://www.twitter.com/newtonparkmain" target='_blank' rel="noopener noreferrer" aria-label='twitter'>
                                <i class="fab fa-twitter"></i>
                            </a>
                        </span>&nbsp; &nbsp;
                    
                    
                        <span classname="facebk">
                            <a href="https://www.facebook.com/newtonparkhotelsmain" target='_blank' rel="noopener noreferrer" aria-label='facebook'>
                                <i class="fab fa-facebook"></i>
                            </a>
                            
                        </span>&nbsp; &nbsp;
                    
                    
                        <span classname="insta">
                            <a href="http://www.instagram.com/newtonparkhotelsmain" target='_blank' rel="noopener noreferrer" aria-label='insta'>
                                <i class="fab fa-instagram"></i>
                            </a>
                        </span>
                    </div>
                </center>
                
            </div>
        </div>
    )
}

export default Footer;